import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Alert, Button } from "reactstrap";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";
import HeadTags from "components/HeadTags";

const Partners = props => {
  const { homepage } = props;
  const { partners } = useContext(StoreContext);
  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <>
      {!homepage && <HeadTags title="Partners" />}
      <section className={`partners${homepage ? " partners--homepage" : ""} `}>
        <header className="partners__header">
          <h1 dangerouslySetInnerHTML={{ __html: partners.headLine }} />
        </header>
        <div className="partners__body">
          {partners.error && <Alert color="danger">{partners.error}</Alert>}
          {partners.loading ? (
            <div className="partners__loading">
              <Loading bg="transparent" />
            </div>
          ) : (
            <ul className="partners__list">
              {partners.list &&
                partners.list.map(partner => (
                  <li className="partners__partner" key={partner.id}>
                    <Link to={`/partners/${partner.nameSEO}`}>
                      <img
                        src={partner.image}
                        alt={`Logo: ${partner.nameFull}`}
                      />
                    </Link>
                  </li>
                ))}
            </ul>
          )}
        </div>
        <footer className="partners__footer">
          {homepage ? (
            <Link to="/partners" className="btn btn-link">
              See All Partners
            </Link>
          ) : (
            <Button color="link" onClick={backToTop}>
              Back to top
            </Button>
          )}
        </footer>
      </section>
    </>
  );
};

Partners.propTypes = {
  homepage: PropTypes.bool
};
Partners.defaultProps = {
  homepage: false
};

export default Partners;
